import React from "react";
import SinglePillarContent from "@/components/nds/windows/pillar/SinglePillarContent";

export default function Pillar3SpiritContent({ win }) {
  return <SinglePillarContent pillarId="PILLAR_3_SPIRIT" focus={win?.payload?.focus} />;
}
